// tslint:disable
import { cssRule } from 'typestyle';
import * as csstips from "csstips";
cssRule('.coupon_countdown', {
    height: 18,
    position: 'absolute',
    bottom: 0,
    borderRadius: 8,
    backgroundColor: '#E82929',
    width: '75px',
    left: '50%',
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center,
    textAlign: 'center',
    transform: 'translateX(-50%)',
    '-webkit-transform': 'translateX(-50%)'
});
cssRule('.coupon_countdown .limit-bar-time__num', {
    position: 'relative',
    background: 'url(\"https://static-1253442168.image.myqcloud.com/picture/8173011_3f71e6bc3b5e3d4763cb7bb55c3b7514.jpg-picmsg420\")',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
    display: 'inline-block',
    fontSize: '10px',
    fontWeight: 500,
    width: '14px',
    height: '14px',
    color: '#fff'
    // marginRight: '1px',
    // marginLeft: '1px'
});
cssRule('.coupon_countdown i', {
    fontStyle: 'normal',
    fontSize: '10px',
    color: '#fff',
    "letterSpacing": 0,
    lineHeight: '18px',
    "fontWeight": 500
});
cssRule('.coupon_countdown .limit-bar-time', {
    textAlign: 'center',
    position: 'relative',
    display: 'flex',
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center
});
cssRule('.coupon_countdown .limit-bar-time span', {
    display: 'inline-block',
    fontSize: '10px'
});
cssRule('.coupon_countdown .limit-bar-time i', {
    display: 'inline-block',
    height: 18,
    lineHeight: '18px'
});


// WEBPACK FOOTER //
// ./src/components/CountDown/CountDown.style.ts